import React, { useEffect, useMemo } from "react";
import { useParams } from "react-router-dom";
import { INSPECTOR_PANIC_STEPS } from "./panicConfig";

function printStyles() {
  return `
    body{font-family:system-ui,-apple-system,BlinkMacSystemFont,"Segoe UI",sans-serif;color:#0f172a;margin:0;background:#f8fafc}
    .wrap{max-width:960px;margin:0 auto;padding:24px}
    .card{background:#fff;border:1px solid #e2e8f0;border-radius:18px;padding:22px;margin-bottom:16px}
    h1{font-size:28px;margin:0 0 8px}
    h2{font-size:18px;margin:0 0 12px}
    .muted{color:#64748b;font-size:14px}
    .badge{display:inline-block;padding:6px 10px;border-radius:999px;background:#e2e8f0;font-size:12px;font-weight:700;color:#334155}
    .grid{display:grid;grid-template-columns:1fr;gap:12px}
    .item{border:1px solid #e2e8f0;border-radius:14px;padding:12px 14px;background:#f8fafc;font-size:14px}
    .actions{display:flex;gap:10px;flex-wrap:wrap;margin-bottom:16px}
    .btn{appearance:none;border:1px solid #cbd5e1;background:#fff;color:#0f172a;padding:10px 14px;border-radius:12px;font-size:14px;font-weight:700;text-decoration:none;cursor:pointer}
    .btn.primary{background:#0f172a;border-color:#0f172a;color:#fff}
    .links{margin-top:14px;display:flex;flex-wrap:wrap;gap:10px}
    .link{display:inline-block;border:1px solid #cbd5e1;border-radius:12px;padding:10px 14px;text-decoration:none;color:#0f172a;font-weight:700}
    @media print{
      body{background:#fff}
      .wrap{padding:0}
      .card{box-shadow:none;break-inside:avoid}
      .actions{display:none}
    }
  `;
}

export default function InspectorSectionPrintPage() {
  const { sectionId } = useParams();

  const step = useMemo(
    () => INSPECTOR_PANIC_STEPS.find((item) => item.id === sectionId) || null,
    [sectionId]
  );

  const links = useMemo(() => {
    if (!step) return [];
    if (Array.isArray(step.moduleLinks)) return step.moduleLinks;
    if (step.modulePath) {
      return [{ path: step.modulePath, label: step.moduleLabel || "Apri modulo" }];
    }
    return [];
  }, [step]);

  useEffect(() => {
    if (!step) return undefined;
    const timeoutId = window.setTimeout(() => {
      window.print();
    }, 250);
    return () => window.clearTimeout(timeoutId);
  }, [step]);

  if (!step) {
    return (
      <div className="min-h-screen bg-slate-100 p-6">
        <style>{printStyles()}</style>
        <div className="wrap">
          <div className="card">
            <h1>Sezione non trovata</h1>
            <p className="muted">La sezione richiesta non esiste oppure non e piu disponibile.</p>
            <div className="actions">
              <button type="button" className="btn primary" onClick={() => window.close()}>Chiudi</button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-slate-100 p-6">
      <style>{printStyles()}</style>
      <div className="wrap">
        <div className="actions">
          <button type="button" className="btn primary" onClick={() => window.print()}>
            Stampa / Salva PDF
          </button>
          <button type="button" className="btn" onClick={() => window.close()}>
            Chiudi
          </button>
        </div>

        <div className="card">
          <div className="badge">Panic Mode / Ispettore</div>
          <h1>{step.title}</h1>
          {step.objective && <p><strong>Obiettivo ispettivo:</strong> {step.objective}</p>}
          <p className="muted">{step.instruction}</p>
        </div>

        {links.length > 0 && (
          <div className="card">
            <h2>Accessi rapidi collegati</h2>
            <div className="links">
              {links.map((link) => (
                <a key={`${step.id}-${link.path}`} className="link" href={link.path}>
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        )}

        {Array.isArray(step.checklist) && step.checklist.length > 0 && (
          <div className="card">
            <h2>Checklist riepilogativa</h2>
            <div className="grid">
              {step.checklist.map((item) => (
                <div key={item} className="item">{item}</div>
              ))}
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
